// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] + "." + {"102":"8c7fdec0","133":"7b5b15b4","182":"c97c5cb1"}[chunkId] + ".chunk.js";
};